function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("Upload your csv of pre computed pairwise correlations. To avoid domain names being cut off, we recommend using short domain names.")]),_vm._v(" "),_c('p',[_vm._v("By default, all correlations are shown. Red ribbons represent negative correlations, while blue represent positive.")]),_vm._v(" "),_c('p',[_vm._v("Use the blue bar to the right of the screen to customize the view, including the correlation threshold, and colors of correlation ribbons. Customizations can be saved using \"Quick Settings\".")]),_vm._v(" "),_c('p',[_vm._v("Consult the "),_c('router-link',{attrs:{"to":"/tutorial"}},[_vm._v("tutorial")]),_vm._v(" and "),_c('router-link',{attrs:{"to":"/faq"}},[_vm._v("FAQ")]),_vm._v(" for more information.")],1)])}
var staticRenderFns = []

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }